<mat-card
  appearance="outlined"
  [ngClass]="getBgClassFromTargetRatio(ratio)"
  [class.flex-start]="!(target > 0)"
>
  <mat-card-subtitle>
    <p>
      <ng-content select="app-card-subtitle"></ng-content>
    </p>
  </mat-card-subtitle>
  <mat-card-title>
    <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
    <span class="target-value"> {{ value }} </span>
  </mat-card-title>
  <mat-card-content *ngIf="target > 0">
    <div class="progressTrack">
      <div
        class="progressTrail"
        [ngStyle]="{
          width:
            'calc(' +
            getTrailOffsetFromRatio(ratio) * 100 +
            '% - var(--widthOffset))'
        }"
      ></div>
      <div
        #progressTarget
        class="progressTarget"
        [ngStyle]="{
          right: getTargetOffset() + 'px'
        }"
      >
        <p class="progressTargetLabel" *ngIf="!reverseTargetTextDirection">
          {{ target }} {{ targetText }}
        </p>
        <p class="progressTargetLabel" *ngIf="reverseTargetTextDirection">
          {{ targetText }} {{ target }}
        </p>
        <hr />
      </div>
    </div>
  </mat-card-content>
</mat-card>
